import { ItemLabelModel } from '../../components/dropdown/models/dropdown-props.model';

export const optionEquality = <T>(
  option: ItemLabelModel<T>,
  value: ItemLabelModel<T>
): boolean => option.id === value.id;
